import React from 'react';
import {Fragment} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, RouteProps} from 'react-router';

import {AppRoutePathFunction} from '../logic/routes';
import {RootState} from '../logic/store';
import {AuthenticationStatus, State as AuthenticationState} from '../logic/store/authenticationStore';

interface MapStateToProps {
  authenticationState?: AuthenticationState;
}

const ComponentWrapper: React.FunctionComponent<MapStateToProps> = props => {
  if (
    !(
      props.authenticationState.status === AuthenticationStatus.Offline ||
      props.authenticationState.status === AuthenticationStatus.LoggedIn
    )
  ) {
    return <Redirect to={AppRoutePathFunction.Login()} push={true} />;
  }

  return <Fragment>{props.children}</Fragment>;
};

const mapStateToProps = (state: RootState): MapStateToProps => ({
  authenticationState: state.authentication
});

const ConnectedComponentWrapper = connect(mapStateToProps)(ComponentWrapper);

const PrivateRoute: React.FunctionComponent<RouteProps> = props => {
  const {component, ...rest} = props;

  const buildRouteRenderFn = (Component: React.ComponentType) => {
    return (routeProps: RouteProps): React.ReactNode => {
      if (!Component) {
        return null;
      }

      return (
        <ConnectedComponentWrapper>
          <Component {...routeProps} />
        </ConnectedComponentWrapper>
      );
    };
  };

  return <Route {...rest} render={buildRouteRenderFn(component)} />;
};

export default PrivateRoute;
